<template>
    <div class="page-container">
        <md-app md-mode="fixed-last" md-waterfall>
            <md-app-toolbar class="md-dense md-primary" v-bind:class="{ inactive: loggedInUser === null }">
                <div class="md-toolbar-row">
                    <div class="md-toolbar-section-start">
                        <md-button @click="menuVisible = !menuVisible" class="md-icon-button">
                            <md-icon>menu</md-icon>
                        </md-button>

                        <span class="md-title">Planning {{ configuration?.companyName }}</span>
                    </div>

                    <!--          <div class="md-toolbar-section-end">-->
                    <!--            <md-button class="md-icon-button">-->
                    <!--              <md-icon>more_vert</md-icon>-->
                    <!--            </md-button>-->
                    <!--          </div>-->
                </div>
            </md-app-toolbar>

            <md-app-drawer v-show="isLoggedIn" :md-active.sync="menuVisible">
                <md-toolbar class="md-transparent" md-elevation="0" style="text-align: center">
                    <img alt="Phrospr logo" id="menu-logo" src="web_logo.png" width="40" />
                    <h5 style="padding-left: 25px">{{ loggedInUser ? loggedInUser.first_name : '' }}</h5>
                </md-toolbar>

                <md-list>
                    <md-list-item @click="navigate('/planning')">
                        <md-icon>home</md-icon>
                        <span class="md-list-item-text">Planning</span>
                    </md-list-item>

                    <md-list-item @click="navigate('/quote/overview')" v-if="configuration?.quotes?.enabled">
                        <md-icon>request_quote</md-icon>
                        <span class="md-list-item-text">Offerte</span>
                    </md-list-item>

                    <md-list-item
                        v-if="configuration?.workOrders?.enabled === true"
                        @click="navigate('/WorkOrder/overview')"
                    >
                        <md-icon>assignment</md-icon>

                        <span class="md-list-item-text">Werkbon</span>
                    </md-list-item>

                    <md-list-item
                        v-if="configuration?.inventory?.enabled === true"
                        @click="navigate('/Inventory/overview')"
                    >
                        <md-icon>inventory</md-icon>

                        <span class="md-list-item-text">Inventaris</span>
                    </md-list-item>

                    <md-list-item @click="navigate('/about')">
                        <md-icon>error</md-icon>
                        <span class="md-list-item-text">About</span>
                    </md-list-item>

                    <md-list-item @click="logout" v-show="isLoggedIn">
                        <span class="md-list-item-text">Logout</span>
                    </md-list-item>
                </md-list>
            </md-app-drawer>

            <md-app-content>
                <router-view></router-view>
            </md-app-content>
        </md-app>
    </div>
</template>

<style lang="scss" scoped>
.md-app {
    border: 1px solid rgba(#000, 0.12);
}

// Demo purposes only
.md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
    height: 100vh;
}

#menu-logo {
    max-height: 100px;
}

.page-container {
    min-height: 100vh;

    > * {
        min-height: 100vh;
    }
}

.inactive {
    opacity: 0;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { appStore } from '@/store';
import { logout, user$, configuration$ } from '@phrospr/lib-web-core';
import { IConfiguration } from '@phrospr/lib-models';

// start store
const loadedStore = appStore;

@Component({
    name: 'PhrosprApp',
})
export default class App extends Vue {
    menuVisible = false;
    loaded = false;

    constructor() {
        super();
        configuration$.then(configuration => this.$store.commit('setConfiguration', configuration));
        user$.then(user => {
            this.loaded = true;
            this.$store.commit('setUser', user);
        });
        setTimeout(() => {
            this.loaded = true;
        }, 500);
    }

    get loggedInUser() {
        return this.$store.state.user;
    }

    get configuration(): Partial<IConfiguration> {
        return this.$store.state.configuration;
    }

    get isLoggedIn() {
        return !this.loaded || !!this.$store.state.user;
    }

    navigate(url) {
        this.$router.push(url);
        this.menuVisible = false;
    }

    logout() {
        logout();
    }
}
</script>

<style lang="scss">
@import 'main.scss';

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
.md-menu-content {
    z-index: 1100 !important; // Higher than the .md-dialog's 1000
}

/* 2. Fix the Dialog depth so the menu can sit on top */
.md-dialog {
    z-index: 1000 !important;
}

/* 3. Ensure the search box inside the dialog doesn't clip its children */
.md-dialog-container {
    overflow: visible !important;
    display: flex;
}
</style>
